import { render, staticRenderFns } from "./WeekGoal.vue?vue&type=template&id=39c31c46&scoped=true"
import script from "./WeekGoal.vue?vue&type=script&lang=js"
export * from "./WeekGoal.vue?vue&type=script&lang=js"
import style0 from "./WeekGoal.vue?vue&type=style&index=0&id=39c31c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c31c46",
  null
  
)

export default component.exports